import { ITitleTextMultiColumnImageTitleText, IItem } from './types';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@components/CustomPrismicLink';
import HyperLink from '@monofront/design-system/components/HyperLink';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapTitleTextMultiColumnImageTitleText } from './mapTitleTextMultiColumnImageTitleText';

const TitleTextMultiColumnImageTitleText: React.FC<
  ITitleTextMultiColumnImageTitleText
> = ({ items, text, title, buttonLabel, link }) => {
  return (
    <section className="root">
      <RichText render={title} />
      <RichText render={text} serializeHyperlink={CustomPrismicLink} />
      <div className="container">
        {items.map((item: IItem, index: number) => {
          return (
            <div key={index} className="item">
              <div className="img">
                <ResponsiveImage
                  height={60}
                  width={60}
                  src={item.image}
                  alt={item.alt}
                />
              </div>
              <div className="text">
                <RichText render={item.title} />
                <RichText
                  render={item.text}
                  serializeHyperlink={CustomPrismicLink}
                />
              </div>
            </div>
          );
        })}
      </div>
      {link && buttonLabel && (
        <div className="button-link">
          <HyperLink to={link}>{buttonLabel}</HyperLink>
        </div>
      )}
      <style jsx>{`
        .root :global(h1) {
          margin-bottom: ${!text.length ? `var(--space-5)` : '0'};
        }

        .root :global(a) {
          color: var(--clr-link);
          text-decoration: underline;
        }

        .root :global(a:hover),
        .root :global(a:focus) {
          opacity: var(--opacity-link-hover);
          text-decoration: none;
        }

        .root :global(strong) {
          color: rgba(0, 0, 0, 0.6);
        }

        .img {
          margin: 30px;
          min-width: 45px;
        }

        .root :global(h3) {
          font-weight: var(--font-weight-bold);
        }

        .root :global(p) {
          padding-top: 15px;
        }

        .container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          grid-gap: 20px;
          text-align: center;
        }

        .button-link {
          text-align: center;
          margin-top: var(--space-6);
        }

        @media (max-width: 800px) {
          .container {
            display: flex;
            flex-direction: column;
          }

          .item {
            display: flex;
            align-items: center;
          }

          .root :global(img) {
            margin: 0 var(--space-3) 0 0;
          }
        }
      `}</style>
    </section>
  );
};

export default withSlice(
  TitleTextMultiColumnImageTitleText,
  mapTitleTextMultiColumnImageTitleText,
);
